<template>
    <div>
        <address-edit :address="address"
                      :countries="countriesArray"
                      @error-occurred="showErrorModal()"
                      @default-address-changed="defaultAddressChanged"
                      @address-updated="addressUpdated"
                      @close="closeEditCollapse(address.id_address)"
        ></address-edit>
    </div>
</template>

<script>
    import AddressEdit from "./AddressEdit";
    import AddressCreate from "./AddressCreate";
    import ErrorMessage from "./ErrorMessage";
    import ModalVue from "./ModalVue";

    export default {
        name: "AddressEditPage",
        props: {
            'address': Object,
            'countries': Object,
            'backLink': String,
        },
        components: { AddressEdit },
        data() {
            return {
                countriesArray: []
            }
        },
        mounted() {
            for (let countryId in this.countries) {
                this.countriesArray.push(this.countries[countryId]);
            }
        },
        methods: {
            showErrorModal() {
            },
            closeEditCollapse(addressId) {
            },
            defaultAddressChanged() {
            },
            addressUpdated() {
                if (this.backLink) {
                    window.location.href = this.backLink;
                }
            },
        }
    }
</script>

<style scoped>

</style>
